export {
  type UserGraphemePronunciationCard,
  userGraphemePronunciationCardTable,
} from "#user-grapheme-pronunciation-card-table";
